/** PrepaidItems index for Mortgage Insurance on HUD/CD page 2. */
export const MI_PREPAID_INDEX = 1

export const miPrepaidKey = (field: string) => `PrepaidItems.${MI_PREPAID_INDEX}.${field}`

/**
 * Bytepro keys for loan-level MI fields — replace values when bytepro mapping is confirmed.
 */
export const MI_LOAN_KEYS = {
  pmiType: 'Loan.PMIType',
  miPremiumPct: 'Loan.MIPremiumPct',
  miPremiumAmt: 'Loan.MIPremiumAmt',
  miPremiumEstimatePct: 'Loan.MIPremiumEstimatePct',
  monthlyMiPremiumYrs1Pct: 'Loan.MIMonthlyPremiumYrs1Pct',
  monthlyMiPremiumYrs1Amt: 'Loan.MIMonthlyPremiumYrs1Amt',
  monthlyMiPremiumYrs1EstimatePct: 'Loan.MIMonthlyPremiumYrs1EstimatePct',
  monthlyMiPremiumYrs2Pct: 'Loan.MIMonthlyPremiumYrs2Pct',
  monthlyMiPremiumYrs2Amt: 'Loan.MIMonthlyPremiumYrs2Amt',
  monthlyMiPremiumYrs2EstimatePct: 'Loan.MIMonthlyPremiumYrs2EstimatePct',
  ltvCutoffPct: 'Loan.MILTVCutoffPct',
  ltvCutoffMonth: 'Loan.MILTVCutoffMonth',
  prepaidMiWillBe: 'Loan.PrepaidMIWillBe',
} as const

export const HUD1_MI_MONTHS_OV_KEY = 'HUD1.MIMonthsOV'

/** Common PMI type options (bytepro enum TBD). */
export const PMITypeMap: Record<number, string> = {
  0: '',
  1: 'Single Prem. Non-Refundable',
  2: 'Single Prem. Refundable',
  3: 'Monthly',
  4: 'Split Premium',
}

export const PrepaidMIWillBeMap: Record<number, string> = {
  0: '',
  1: 'Refunded',
  2: 'Not Refunded',
}
